import * as ModalComponents from "../layouts";

export const ModalConstants = {
  REGISTER_FORM_MODAL: ModalComponents.RegisterFormModal,
  CONFIRM_MODAL: ModalComponents.ConfirmModal,
  SIGN_IN_FORM_MODAL: ModalComponents.SignInFormModal,
  FORGOT_PASSWORD_FORM_MODAL: ModalComponents.ForgotPasswordFormModal,
  PROFILE_ACTION_BUTTONS_MODAL: ModalComponents.ProfileActionButtonsModal,
  SWEET_OR_HOT_MODAL: ModalComponents.SweetOrHotModal,
  INFORMATION_MODAL: ModalComponents.CommonInfoModal,
  RECOVER_SUGGEST_MODAL: ModalComponents.RecoverSuggestModal,

  LADY_PROFILE_SLIDER_MODAL: ModalComponents.LadySliderContextWrapper,
  LADY_PROFILE_SLIDER_V2_MODAL: ModalComponents.LadySliderV2Modal,
  MAN_PROFILE_SLIDER_MODAL: ModalComponents.ManProfileSliderModal,
  NEWSFEED_SLIDER_MODAL: ModalComponents.NewsfeedSliderModal,

  CREATE_PHONE_CALL_MODAL: ModalComponents.CreatePhoneCallModal,
  CREATE_LETTER_MODAL: ModalComponents.CreateLetterModal,
  PROMO_CODE_MODAL: ModalComponents.PromoCodeModal,
  CREATE_PURCHASE_COINS_MODAL: ModalComponents.CreatePurchaseCoinsModal,
  CREATE_ONE_TIME_PURCHASE_COINS_MODAL:
    ModalComponents.CreateOneTimePurchaseCoinsModal,
};

export type ModalConstantKeys = keyof typeof ModalConstants;
export type ModalComponentType<K extends ModalConstantKeys> =
  (typeof ModalConstants)[K];

export type ModalComponentProps<K extends ModalConstantKeys> =
  React.ComponentProps<ModalComponentType<K>>;
